import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = () => ({
  auctions: [],
  auction: null,
  lots: null,
  lot: null,
  bids: [],
  pagination: null,
});

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
